import ShortLoadingAnimation from './modules/short-loading.js'
/**
 * 指定時間後にpromiseを返す
 *
 * @param {int} ms
 */
function sleep (ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve()
    }, ms)
  })
}
/**
 * 要素を生成する。
 * @version 1.0.1
 *
 * @param  {String} dom DOMの種類
 * @param  {String} cl [cl=""]  クラス属性
 * @param  {String} inner [inner=""]  innerHTML
 * @param  {Array}  obj [obj=[]] [{key:属性,val:value},{...}]の形式で渡す
 * @param  {HTMLObject} append appendChildする場合は親の要素を指定
 * @return {Object} HTML Elementを返す
 */
const createDom = (dom, cl = '', inner = '', obj = [], append = '') => {
  const returnEl = document.createElement(dom)
  if (cl !== '') {
    if (typeof (cl) === 'string' || cl instanceof String) {
      returnEl.classList.add(cl)
    } else if (cl instanceof Array) {
      cl.forEach(c => {
        returnEl.classList.add(c)
      })
    }
  }
  if (obj.length) {
    obj.forEach((attr, i) => {
      returnEl.setAttribute(attr.key, attr.val)
    })
  }
  if (inner !== '') {
    returnEl.innerHTML = inner
  }
  if (append !== '') {
    append.appendChild(returnEl)
  }
  return returnEl
}
/**
 * @param {Object} getObject ObjectをGETリクエストの形に変換する
 * @return {String} ?aa=bb&cc=ddの形で出力
 */
const transformGetRequestArray = getArray => {
  const returnArray = []
  for (const key in getArray) {
    if (getArray.hasOwnProperty(key) && getArray[key] !== '' && getArray[key] !== undefined) {
      returnArray.push(key + '=' + getArray[key])
    }
  }
  let returnString = returnArray.join('&')
  returnString = '?' + returnString
  return returnString
}
/**
 * オブジェクトの情報から実績一覧のカードのHTMLDOMを生成する。
 * @param {Object} item
 * @return {HTMLObject}
 */
const createWorksCard = item => {
  const cardClass = 'link-card'
  const returnCard = createDom('li', [cardClass, cardClass + '--list'])

  const cardLink = createDom('a', cardClass + '__link', '', [{ key: 'href', val: item.permalink }], returnCard)

  const cardThumbnailArea = createDom('div', cardClass + '__image', '', [], cardLink)

  createDom('img', '', item.views, [{ key: 'src', val: item.thumbnail_url ? item.thumbnail_url : templatePath + '/img/noImage.jpg' }, { key: 'alt', val: item.title + 'のサムネイル' }], cardThumbnailArea)

  createDom('div', cardClass + '__views', item.views, [], cardThumbnailArea)

  const cardTextArea = createDom('div', cardClass + '__text-area', '', [], cardLink)

  createDom('div', cardClass + '__date', `<svg class="link-card__write-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="18"><use href="#svg-pencil"></use></svg>${item.date}`, [], cardTextArea)

  createDom('p', cardClass + '__title', item.title, [], cardTextArea)

  if (item.category_name && item.category_name[0]) {
    const cardCategories = createDom('div', cardClass + '__categories', '<svg class="link-card__category-label" width="16" height="10" viewbox="0 0 16 10"><use href="#category-label" fill="#707070"></use></svg>', [], cardTextArea)
    item.category_name.forEach((name, i) => {
      createDom('span', cardClass + '__category-item', name, [], cardCategories)
    })
  }
  return returnCard
}
/**
 * ページ情報からページナビのHTMLDOMを生成する。
 * @param {Object} item
 * @return {HTMLObject}
 */
const createPageNavigation = (item, worksContent) => {
  const max = item.max_page
  const current = item.current_page
  const paginationClass = 'list-pagination'

  const returnPage = document.createElement('div')
  returnPage.classList.add(paginationClass)

  const pageCheckArray = []
  if (max === 1) {
    return null
  } else if (max <= 5) {
    for (let i = 1; i <= max; i++) {
      pageCheckArray.push(i)
    }
  } else if (current - 2 <= 1) {
    pageCheckArray.push(1, 2, 3, 4, '>', max)
  } else if (current + 2 >= max) {
    pageCheckArray.push(1, '>')
    pageCheckArray.push(max - 3, max - 2, max - 1, max)
  } else {
    pageCheckArray.push(1, '>')
    pageCheckArray.push(current - 1, current, current + 1)
    pageCheckArray.push('>', max)
  }
  pageCheckArray.forEach(page => {
    if (page === '>') {
      const dotNode = document.createElement('div')
      dotNode.classList.add(paginationClass + '__dot')
      dotNode.innerText = '…'
      returnPage.appendChild(dotNode)
    } else {
      const pageNode = document.createElement('div')
      pageNode.classList.add(paginationClass + '__item')
      pageNode.dataset.page = page
      pageNode.innerText = page
      if (page === current) {
        pageNode.classList.add(paginationClass + '__item--current')
      } else {
        pageNode.addEventListener('click', e => {
          const target = e.currentTarget
          const pageData = target.dataset.page
          const params = new URLSearchParams(window.location.search)
          const getParamObject = {
            category: params.has('zCat') ? params.get('zCat') : 'all',
            sort: params.has('zSort') ? params.get('zSort') : '0',
            search: params.has('zS') ? params.get('zS') : '',
            paged: pageData
          }
          params.delete('zPaged')
          params.append("zPaged", pageData)
          const navQuery = params.toString()
          const url = apiUrl + transformGetRequestArray(getParamObject)
          appendContent(url, worksContent, navQuery)
        })
      }
      returnPage.appendChild(pageNode)
    }
  })
  return returnPage
}
/**
 * URLを指定して要素を挿入する
 * @param  {String} url
 * @param  {Object} worksContent
 */
const appendContent = (url, worksContent, query=null) => {
  loadingFlag = true
  const firstLoading = new ShortLoadingAnimation()
  firstLoading.start()
  const worksCardDomArray = []
  let worksListTimeout = ''
  worksContent.innerHTML = ''
  const paginationContent = S('.jsPageNav')
  paginationContent.innerHTML = ''
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  fetch(url)
    .then(res => res.json())
    .then(data => {
      if (data[0] === 'not found') return
      const pageObj = data.shift()
      data.forEach((item, i) => {
        worksCardDomArray.push(createWorksCard(item))
      })
      return pageObj
    })
    .then(pageObj => {
      if (!pageObj) {
        firstLoading.end()
        return
      }
      const cardLength = worksCardDomArray.length
      let cardI = 0
      const appendCard = () => {
        cardI++

        if (cardI <= cardLength) {
          worksContent.appendChild(worksCardDomArray[cardI - 1])
          sleep(80)
            .then(() => {
              worksCardDomArray[cardI - 1].classList.add('works-lists-card--visible')
            })
          worksListTimeout = setTimeout(() => {
            appendCard()
          }, 80)
        } else {
          clearTimeout(worksListTimeout)
          const paginationElement = createPageNavigation(pageObj, worksContent)
          if (paginationElement === null) {
            paginationContent.style.display = 'none'
          } else {
            paginationContent.style.display = 'block'
            paginationContent.appendChild(paginationElement)
          }
        }
      }
      appendCard()
      if(query !== null)
      {
        const currentUrl = location.protocol + '//' + location.host + location.pathname + '?' + query
        window.history.pushState({url: url,query: query},'',currentUrl)
      }
      return sleep(1000)
    })
    .then(() => {
      firstLoading.end()
      loadingFlag = false
    })
}
let loadingFlag = false; let apiUrl
const articleTitle = S('.jsBlogTitle')
window.addEventListener('DOMContentLoaded', () => {
  const worksContent = S('.jsWorksContent')
  const moneyContent = S('.jsMoneyContent')
  if (typeof worksContent !== 'undefined' || typeof moneyContent !== 'undefined') {
    let apiType, targetContent
    if (typeof worksContent !== 'undefined') {
      apiType = 'blog'
      targetContent = worksContent
    } else if (typeof moneyContent !== 'undefined') {
      apiType = 'money'
      targetContent = moneyContent
    }
    apiUrl = homeUrl + '/wp-json/articles/' + apiType
    let params = new URLSearchParams(window.location.search)
    let getParamObject = {
      category: params.has('zCat') ? params.get('zCat') : 'all',
      sort: params.has('zSort') ? params.get('zSort') : '0',
      search: params.has('zS') ? params.get('zS') : '',
      year: params.has('zYear') ? params.get('zYear') : undefined,
      month: params.has('zMonth') ? params.get('zMonth') : undefined,
      paged: params.has('zPaged') ? params.get('zPaged') : 1,
    }
    if (params.has('zYear') && params.get('zYear') !== '' && !isNaN(params.get('zYear'))) {
      articleTitle.innerText = params.get('zYear') + '年' + params.get('zMonth') + '月の記事一覧'
      S('.jsCatItem')[0].classList.remove('articles-customize__list-item--selected')
    } else {
      articleTitle.innerText = '記事一覧'
    }
    const firstQuery = params.toString()
    const url = apiUrl + transformGetRequestArray(getParamObject)
    appendContent(url, targetContent, firstQuery)

    const sortItem = S('.jsSortItem')
    sortItem.forEach((button, i) => {
      button.addEventListener('click', e => {
        const target = e.target
        if (target.classList.contains('articles-customize__list-item--selected') && loadingFlag) return
        loadingFlag = true

        S('.articles-customize__list-item--selected')[0].classList.remove('articles-customize__list-item--selected')
        target.classList.add('articles-customize__list-item--selected')

        const currentUrl = new URL(window.location)
        currentUrl.searchParams.set('zSort', target.dataset.sort)
        params = new URLSearchParams(window.location.search)
        params.delete('zSort')
        params.delete('zPaged')
        params.append('zSort', target.dataset.sort)

        getParamObject = {
          category: params.has('zCat') ? params.get('zCat') : 'all',
          sort: params.has('zSort') ? params.get('zSort') : '0',
          search: params.has('zS') ? params.get('zS') : '',
          paged: params.has('zPaged') ? params.get('zPaged') : 1,
        }
        const categoryQuery = params.toString()
        const categoryUrl = apiUrl + transformGetRequestArray(getParamObject)
        appendContent(categoryUrl, targetContent, categoryQuery)
      })
    })
    const catItem = S('.jsCatItem')
    catItem.forEach((button, i) => {
      button.addEventListener('click', e => {
        const target = e.target
        if (target.classList.contains('articles-customize__list-item--selected') && loadingFlag) return
        loadingFlag = true

        const beforeSelected = S('.articles-customize__list-item--selected')[1]
        if (beforeSelected) {
          beforeSelected.classList.remove('articles-customize__list-item--selected')
        }
        target.classList.add('articles-customize__list-item--selected')
        const termId = target.dataset.termid === 'all' ? '' : target.dataset.termid
        const currentUrl = new URL(window.location)
        currentUrl.searchParams.set('zCat', termId)
        currentUrl.searchParams.set('zS', '')
        currentUrl.searchParams.set('zYear', '')
        articleTitle.innerText = '記事一覧'

        const articlesSearchInput = S('.jsArticlesSearchInput')
        articlesSearchInput.value = ''
        params = new URLSearchParams(window.location.search)
        params.delete('zCat')
        params.delete('zPaged')
        params.delete('zS')
        params.delete('zYear')
        params.delete('zMonth')
        params.append('zCat', termId)

        getParamObject = {
          category: params.has('zCat') ? params.get('zCat') : 'all',
          sort: params.has('zSort') ? params.get('zSort') : '0',
          search: params.has('zS') ? params.get('zS') : '',
          year: params.has('zYear') ? params.get('zYear') : '',
          month: params.has('zMonth') ? params.get('zMonth') : '',
          paged: params.has('zPaged') ? params.get('zPaged') : 1,
        }
        const categoryQuery = params.toString()
        const categoryUrl = apiUrl + transformGetRequestArray(getParamObject)
        appendContent(categoryUrl, targetContent, categoryQuery)
      })
    })
    const searchSort = () => {
      const currentUrl = new URL(window.location)
      const value = articlesSearchInput.value
      currentUrl.searchParams.set('zS', value)

      params = new URLSearchParams(window.location.search)
      if (value !== '' && value !== null) {
        S('.jsCatItem')[0].classList.remove('articles-customize__list-item--selected')
      }
      params.delete('zS')
      params.append('zS', articlesSearchInput.value)

      getParamObject = {
        category: params.has('zCat') ? params.get('zCat') : 'all',
        sort: params.has('zSort') ? params.get('zSort') : '0',
        search: params.has('zS') ? params.get('zS') : '',
        paged: params.has('zPaged') ? params.get('zPaged') : 1,
      }
      const categoryQuery = params.toString()
      const categoryUrl = apiUrl + transformGetRequestArray(getParamObject)
      appendContent(categoryUrl, targetContent, categoryQuery)
    }
    const articlesSearchInput = S('.jsArticlesSearchInput')
    const articlesSearchButton = S('.jsArticlesSearchButton')
    articlesSearchButton.addEventListener('click', searchSort)
    articlesSearchInput.addEventListener('keyup', e => {
      if (e.key === 'Enter') {
        searchSort()
      }
    })
    window.addEventListener('popstate', e => {
      if(e.state === null)
      {
        window.history.back()
      }
      const url = e.state.url
      appendContent(url, targetContent, null)
      params = new URLSearchParams(e.state.query)
      const selectedName = 'articles-customize__list-item--selected'
      if(params.has('zSort'))
      {
        const selectedItem = S('.'+selectedName)[0]
        if(selectedItem)
        {
          selectedItem.classList.remove(selectedName)
        }
        S('.jsSortItem[data-sort="'+params.get('zSort')+'"]').classList.add(selectedName)
      }else
      {
        const selectedItem = S('.'+selectedName)[0]
        if(selectedItem)
        {
          selectedItem.classList.remove(selectedName)
        }
        S('.jsSortItem[data-sort="0"]').classList.add(selectedName)
      }
      if(params.has('zCat'))
      {
        const selectedItem = S('.'+selectedName)[1]
        if(selectedItem)
        {
          selectedItem.classList.remove(selectedName)
        }
        if(params.get('zCat') === '')
        {
          S('.jsCatItem[data-termid="all"]').classList.add(selectedName)
        }else
        {
          S('.jsCatItem[data-termid="'+params.get('zCat')+'"]').classList.add(selectedName)
        }
      }else
      {
        const selectedItem = S('.'+selectedName)[1]
        if(selectedItem)
        {
          selectedItem.classList.remove(selectedName)
        }
        S('.jsCatItem[data-termid="all"]').classList.add(selectedName)
      }
      if(params.has('zS'))
      {
        if (S('.jsCatItem')[0].classList.contains('articles-customize__list-item--selected') && params.get('zS') !== '') {
          S('.jsCatItem')[0].classList.remove('articles-customize__list-item--selected')
        }
        S('.jsArticlesSearchInput').value = params.get('zS')
      }else
      {
        S('.jsArticlesSearchInput').value =''
      }
      if(params.has('zYear') && params.has('zMonth'))
      {
        articleTitle.innerText = params.get('zYear') + '年' + params.get('zMonth') + '月の記事一覧'
      }else
      {
        articleTitle.innerText = '記事一覧'
      }
    })
  }
})
